import { HfarmCorporate } from "./hfarm_corporate_module.js";
import { mqLess } from 'src/modules/viewport_module';
import { get } from 'lodash';

const hfarmCorporateTileMixin = {
  props: {
    animation: {
      type: Boolean,
      default: true,
    }
  },
  mounted() {
    Vue.nextTick(() => {
      // Animation management.
      if (this.animation) {
        this.registerAnimation();
      }
    });
  },
  methods: {
    registerAnimation: HfarmCorporate.registerAnimation,
    getContentURL: Fandom.getContentURL,
    getBackgroundUrl: Fandom.getBackgroundUrl,
    animationClass() {
      if (this.animation) {
        return "inview_animate";
      }
    },
  },
  computed: {
    textAlign() {
      // Allowed values: left, right and center.
      return (this.content.text_align) ? `text-${this.content.text_align}` : null;
    },
    tileUrl() {
      if (this.content.url && this.content.url.url == "$video" && this.isYoutubePresent) {
        return "javascript:void(0)";
      }
      return this.content.url ? this.content.url.url : this.getContentURL(this.content) ? this.getContentURL(this.content) : "javascript:void(0)";
    },
    textColor() {
      if (this.content.text_color) {
        return {"color": `${this.content.text_color} !important`};
      } else {
        return {"color": "#FFFFFF"};
      }
    },
    image() {
      if (this.content.background_color && !this.content.thumbnail && !this.content.thumbnail_mobile) {
        return null;
      }
    
      let imageURL;
    
      if (mqLess('sm') && this.content.thumbnail_mobile) {
        imageURL = this.getContentResponsiveImageURL('thumbnail_mobile');
      } else if (this.content.thumbnail) {
        imageURL = this.getContentResponsiveImageURL('thumbnail');
      } else if (this.content.image) {
        imageURL = this.getContentResponsiveImageURL('image');
      } else {
        imageURL = this.getBackgroundUrl(this.fallbackImage);
      }
    
      if (this.content.isotope_size != 'ultrawidecontent') {
        imageURL = imageURL.replace('/original/', '/thumb/');
      }
    
      return imageURL;
    },
    fallbackImage()  {
      return get(globalState.pageModel, ['layout', 'content', 'tile_fallback_image', 'url'], '');
    }
  }
};

const HFarmCorporateNavbarMixin = {
  methods: {
    isTouchDevice: Fandom.isTouchDevice,
    isItemActive(item) {
      // When url is a ContentLink extra field type the content name can be used as matching 
      // name when mathing name is missing.
      const contentName = get(item, ['url','content'], '');
      item.matching_name = item.matching_name || contentName;
      const re = new RegExp(`^(${item.matching_name})$`);
      return re.test(globalState.pageModel.main_content_name);
    },
    getItems(items) {
      if (!items) {
        return [];
      } else {
        return items.filter(el => !el.hidden);
      }
    },
    isTwoLevelsMenu(item) {
      return this.getItems(item.items).some(el => !!el.items);
    },
    getItemHref(item) {
      if (!item.url) {
        return 'javascript:void(0)';
      }
      if (this.content.preserve_url_params) {
        return item.url.url + '?' + window.location.search.substr(1);
      } else {
        const anchor = item.url.url.split("#")[1];
        return anchor ? `#${anchor}`: item.url.url;
      }
    },
    getItemTitle(item) {
      const urlTitle = get(item, ['url','title'], false);
      return urlTitle ? get(item, ['url','title'], false) : item.title;
    }
  }
}

const HFarmCorporateModalMixin = {
  data() {
    return {
      isModalVisible: false
    };
  },
  computed: {
    modalButtonClass() {
      return this.content.modal_button_class ? this.content.modal_button_class : 'btn-primary'
    }
  },
  methods: {
    showModal() {
      Fandom.emit('show-fullscreen-modal', {
        content: this.content.modal,
        containerContent: this.containerContent
      });
    }
  }
}

export {
  hfarmCorporateTileMixin,
  HFarmCorporateNavbarMixin,
  HFarmCorporateModalMixin
};
